import styles from "./styles/Input.module.css";

import RegisterError from "./RegisterError";

export default function Input({
  className = "",
  type,
  label,
  value,
  onChange,
  errorCode,
}) {
  const contStyle = errorCode ? styles.cont + " " + styles.error : styles.cont;

  return (
    <div className={contStyle + " " + className}>
      <label className={styles.label}>{label}</label>
      <input
        onChange={(e) => onChange(e)}
        type={type}
        value={value}
        defaultValue={value}
      />
      {errorCode && <RegisterError errorCode={errorCode} />}
    </div>
  );
}
